var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-item-input",
      staticStyle: { "align-items": "center" }
    },
    [
      _c(
        "el-input-number",
        _vm._g(
          _vm._b(
            { staticStyle: { flex: "1" } },
            "el-input-number",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
      _c("span", [_vm._v("KGS")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }